import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import toast from 'react-hot-toast';
import { getErrorString } from '../../utils';
import { fetchTypesApi } from '../../api/types-api';
import { setQuickLinks } from 'reducers/quick-links-slice';
import { formatOptionsForSelect } from 'utils/filters-util';

const initialState = {
  activeColumns: [],
  typeSources: [],
  types: [],
  loading: true,
  pending: false,
  pagination: {},
};

export const fetchTypesListing = createAsyncThunk('types/listing', async (updatedParamsObject = {}, { dispatch }) => {
  try {
    const paramsObj = {
      ...updatedParamsObject,
    };
    const res = await fetchTypesApi(paramsObj);
    if (res?.status) {
      dispatch(setQuickLinks(res?.user_filters));
    }
    return res;
  } catch (error) {
    toast.error(getErrorString(error));
  }
});

const TypesSlice = createSlice({
  name: 'types',
  initialState,
  reducers: {
    setTypesLoading: (state, action) => {
      state.loading = action?.payload?.loading;
    },
    setTypesActiveColumn: (state, action) => {
      state.activeColumns = action?.payload?.activeColumns;
    },
    setTypesEdit: (state, { payload }) => {
      state.types = state.types?.map((type) => (type?.id === payload?.id ? payload : type));
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchTypesListing.pending, (state) => {
        state.pending = true;
      })
      .addCase(fetchTypesListing.fulfilled, (state, action) => {
        if (state.loading) {
          state.activeColumns = action?.payload?.active_columns || [];
        }
        state.types = action?.payload?.data || [];
        state.typeSources = formatOptionsForSelect({
          list: (action?.payload?.type_sources || []).map((source) => source?.slug),
        });
        state.loading = false;
        state.pending = false;
        state.pagination = action?.payload?.meta?.pagination || {};
      })
      .addCase(fetchTypesListing.rejected, (state) => {
        state.loading = false;
        state.pending = false;
      });
  },
});

export const { setTypesActiveColumn, setTypesLoading, setTypesEdit } = TypesSlice.actions;
export default TypesSlice.reducer;
